const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * `BUN_PUBLIC_UMAMI_WEBSITE_ID`, the Umami website the dashboard reports its flows to.
 *
 * Unset means no events at all, which is what dev, CI and staging get: they share no
 * website id with production, so they cannot add to its numbers. There is no
 * default for the same reason. A value that is set but is not a UUID throws, so the
 * build (scripts/build/dashboard.ts) fails on it rather than shipping events that record
 * nothing, and the server's startup says so loudly.
 */
export const parseUmamiWebsiteId = (raw: string | undefined): string | null => {
  const value = raw?.trim() ?? '';
  if (!value) return null;
  if (!UUID.test(value)) throw new Error(`BUN_PUBLIC_UMAMI_WEBSITE_ID is set but is not a UUID: "${value}"`);
  return value;
};
